




















































import { Component, Mixins } from 'vue-property-decorator'

import AppTitleBar from '@/components/AppTitleBar.vue'
import ClaimFormRefundAccount from '@/components/ClaimFormRefundAccount.vue'
import ClaimReturnFee from '@/components/ClaimReturnFee.vue'
import ClaimReturnMethod from '@/components/ClaimReturnMethod.vue'
import ClaimItemSelect from '@/components/ClaimItemSelect.vue'
import ClaimPolicy from '@/components/ClaimPolicy.vue'
import ClaimReason from '@/components/ClaimReason.vue'

import { ORDERFORM_QUERY, REQUEST_ORDER_CANCELLATION } from '@/gql/order'
import { OrderMixin } from '@/mixins'

@Component({
  components: {
    AppTitleBar,
    ClaimFormRefundAccount,
    ClaimReturnFee,
    ClaimReturnMethod,
    ClaimItemSelect,
    ClaimPolicy,
    ClaimReason
  },
  apollo: {
    orderForm: {
      query: ORDERFORM_QUERY,
      variables () {
        return {
          orderId: this.$route.params.id
        }
      }
    }
  }
})
export default class extends Mixins(OrderMixin) {
  orderForm: {
    id: string;
    order: {
      id: string;
      paymentMethod: string;
      deliveries: {
        id: string;
        seller: {
          id: string;
        };
        orderItems: {
          id: string;
          status: string;
        };
      }[];
    };
  } = {
    id: '',
    order: {
      id: '',
      paymentMethod: '',
      deliveries: []
    }
  }

  get orderDelivery () {
    return this.orderForm.order.deliveries.find(delivery => delivery.id === this.$route.query.orderDeliveryId)
  }

  get sellersRemainedNormalOrderItems () {
    const currentDelivery = this.orderForm.order.deliveries.find(delivery => delivery.id === this.$route.query.orderDeliveryId)
    if (currentDelivery) {
      return this.orderForm.order.deliveries
        .filter(delivery => delivery.seller.id === currentDelivery.seller.id)
        .reduce((acc: { id: string; status: string }[], delivery) => acc.concat(delivery.orderItems), [])
        .filter(orderItem => orderItem.status === 'NONE')
    } else {
      return []
    }
  }

  get cancelType () {
    return this.$route.query.cancelType as string
  }

  selectedReturnMethod = 'BY_SELLER'
  selectedReturnFeeType = 'DEDUCTION'
  selectedCancelReason = ''
  cancelReasonDetail = ''

  inputRefundInfo: {
    refundBankCode: string;
    refundBankAccountHolderName: string;
    refundBankAccount: string;
  } = {
    refundBankCode: '',
    refundBankAccountHolderName: '',
    refundBankAccount: ''
  }

  orderItemSelected: { [key: string]: boolean } = {}

  mounted () {
    if (this.$route.query.orderItemId) {
      this.orderItemSelected = { [`${this.$route.query.orderItemId}`]: true }
    }
  }

  toggleOrderItemSelected (orderItemId: string) {
    this.$set(this.orderItemSelected, orderItemId, !this.orderItemSelected[orderItemId])
  }

  get selectedOrderItemCount () {
    return Object.keys(this.orderItemSelected).filter(id => this.orderItemSelected[id]).length
  }

  get selectedOrderItemIds () {
    return Object.keys(this.orderItemSelected).filter(id => this.orderItemSelected[id])
  }

  get requestCancelEnabled () {
    const itemAndReasonSelected = this.selectedOrderItemCount > 0 && this.selectedCancelReason
    const refundBankInfoCompleted = this.orderForm.order.paymentMethod !== 'VBANK' || (
      this.inputRefundInfo.refundBankCode &&
      this.inputRefundInfo.refundBankAccountHolderName &&
      this.inputRefundInfo.refundBankAccount
    )

    if (this.cancelType === 'REFUND') {
      return itemAndReasonSelected && refundBankInfoCompleted
    } else {
      return itemAndReasonSelected && refundBankInfoCompleted && this.selectedReturnMethod &&
        (!this.isBuyerFault(this.selectedCancelReason) || this.selectedReturnFeeType)
    }
  }

  async requestCancel () {
    const result = confirm(`${this.getOrderCancelTypeText(this.cancelType)} 하시겠습니까?`)
    if (!result) {
      return
    }

    const { data } = await this.$apollo.mutate({
      mutation: REQUEST_ORDER_CANCELLATION,
      variables: {
        input: {
          orderId: this.orderForm.id,
          orderDeliveryId: this.orderDelivery?.id,
          orderItemIds: this.selectedOrderItemIds,
          orderCancelType: this.cancelType,
          orderCancelReason: this.selectedCancelReason,
          orderCancelReasonDetail: this.cancelReasonDetail,
          orderReturningMethod: this.selectedReturnMethod || undefined,
          orderReturningFeeType: this.selectedReturnFeeType || undefined,
          refundBankAccount: this.inputRefundInfo.refundBankAccount,
          refundAccountHolderName: this.inputRefundInfo.refundBankAccountHolderName,
          refundBankName: this.bankDict[this.inputRefundInfo.refundBankCode],
          refundBankCode: this.inputRefundInfo.refundBankCode
        }
      }
    })

    if (data.requestOrderCancellation.success) {
      this.routerReplace(`/orders/${this.orderForm.order.id}/cancels/completed?cancelType=${this.cancelType}`)
    } else {
      await this.showToast(data.requestOrderCancellation.message)
    }
  }
}
